import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getSocket } from '../lib/socket';
import { isUsableMt5Quote } from '../lib/mt5Quote';

/** Subscribes to real-time ticker updates and merges them into the mt5 market query cache. */
export function useTickerSocket(): void {
  const queryClient = useQueryClient();

  useEffect(() => {
    const socket = getSocket();

    const handleTicker = (data: { ticker: Record<string, { price: number; bid: number; ask: number; spread: number; timestamp: string; source?: string }> }) => {
      const ticker = data?.ticker;
      if (!ticker || typeof ticker !== 'object' || Object.keys(ticker).length === 0) return;

      const saneEntries = Object.entries(ticker).filter(([, q]) => isUsableMt5Quote(q.bid, q.ask));
      if (saneEntries.length === 0) return;

      queryClient.setQueryData(
        ['mt5', 'market'],
        (old: { symbolMap?: Record<string, string>; mt5Symbols?: string[]; ticker?: Record<string, unknown> } | undefined) => {
          if (!old) return;
          const merged = { ...(old.ticker ?? {}) };
          for (const [sym, q] of saneEntries) {
            merged[sym] = q;
          }
          return {
            ...old,
            ticker: merged,
          };
        }
      );
    };

    socket.on('dashboard:ticker', handleTicker);

    return () => {
      socket.off('dashboard:ticker', handleTicker);
    };
  }, [queryClient]);
}
